/*(function () {
  'use strict'

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }

        form.classList.add('was-validated')
      }, false)
    })
})()*/

$(function(){  
  // CART FORM VALIDATION

  var cf = $('input[name="attributes[codice_fiscale]"]');
  var company = $('input[name="attributes[ragione_sociale]"]');
  var cf_company = $('input[name="attributes[codice_fiscale_azienda]"]');
  var piva = $('input[name="attributes[partita_iva]"]');
  var pec = $('input[name="attributes[pec]"]');
  var sdi = $('input[name="attributes[sdi]"]');
  
  var customMessage = $('.custom-message');
    
  
  
  $(document).on('change', 'input[name="attributes[tipo_utente]"]', function(){
  	var val = $(this).val();
   	setRequiredFields(val);
  });
  
  
  $('#cartform input[type=submit]').on('click', function(){
  	 $('#cartform').addClass('validated');
  });
  
  
  $(document).on('submit', 'form#cartform', function(e){
    
    var user_type = $('input[name="attributes[tipo_utente]"]:checked').val();
 
    if(user_type == 'Azienda') {    
      if (pec.val() == '' && sdi.val() == '') {
        e.preventDefault();
      	customMessage.show();
      }
    } else {
    	customMessage.hide();
    }
  });

  
  function setRequiredFields(user_type_value){

    
  	 if(user_type_value == 'Privato'){
    	$('.enduser-fields').slideDown();
      	$('.company-fields').slideUp();
       
       //	cf.prop('required',true);
       
      //  company.prop('required',false);
      //  cf_company.prop('required',false);
      //  piva.prop('required',false);
       
    } else if (user_type_value == 'Azienda'){
  
    	$('.enduser-fields').slideUp();
      	$('.company-fields').slideDown();
      
      
      //	cf.prop('required',false);
       
      //  company.prop('required',true);
      //  cf_company.prop('required',true);
      //  piva.prop('required',true);
    }
  }
});
